import { UserLogWithDetail } from "../../../types/users_log.types";
import { UserLogAction } from "../../../types/users_log.types";
import { UserRolesTranslations } from "../../../types/user.types";

export const UserLogTimelineItem = ({
  log,
  user,
  isLast,
  formatDate,
  getActionText,
  getActionColor,
}: {
  log: UserLogWithDetail;
  user: any;
  isLast: boolean;
  formatDate: (date: Date) => string;
  getActionText: (action: UserLogAction) => string;
  getActionColor: (action: UserLogAction) => string;
}) => {
  const date = new Date(log.created_at).toLocaleDateString("es-ES", {
    day: "numeric",
    month: "short",
  });

  const timeColor = (() => {
    switch (log.action) {
      case UserLogAction.CREATION:
      case UserLogAction.ACTIVATION:
      case UserLogAction.REACTIVATION:
        return "bg-green-100 text-green-600";
      case UserLogAction.DEACTIVATION:
      case UserLogAction.DELETION:
        return "bg-red-100 text-red-600";
      default:
        return "bg-blue-100 text-blue-600";
    }
  })();

  return (
    <div className="group relative py-6 pl-8 sm:pl-32">
      <div className="absolute left-2 h-full -translate-x-1/2 translate-y-3 self-start bg-slate-300 px-px group-last:hidden sm:left-0 sm:ml-[6.5rem]"></div>
      <div
        className="absolute left-2 box-content h-2 w-2 -translate-x-1/2 translate-y-1.5 rounded-full border-4 border-slate-50 sm:left-0 sm:ml-[6.5rem]"
        style={{ backgroundColor: getActionColor(log.action) }}
      ></div>

      <div className="mb-1 flex flex-col items-start sm:flex-row">
        <time
          className={`left-0 mb-3 inline-flex h-6 w-20 translate-y-0.5 items-center justify-center rounded-full text-xs font-semibold uppercase sm:absolute sm:mb-0 ${timeColor}`}
        >
          {date}
        </time>
        <div className="text-xl font-bold text-slate-900">
          {getActionText(log.action)}
        </div>
      </div>

      <div className="text-slate-500 mt-2">
        <div className="text-sm mb-2">{formatDate(log.created_at)}</div>
        {log.reason && <p className="text-sm mb-3">{log.reason}</p>}

        {log.performed_by &&
          (log.performed_by.id === user.id ? (
            <p className="text-sm italic mt-2">
              El usuario realizó esta acción sobre sí mismo
            </p>
          ) : (
            <div className="text-sm mt-3 bg-gray-50 p-3 rounded border border-gray-200">
              <p className="font-medium mb-2 text-gray-700">Realizado por:</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <p>
                  <span className="font-medium">Nombre:</span>{" "}
                  {log.performed_by.first_name || log.performed_by.last_name
                    ? `${log.performed_by.first_name || ""} ${
                        log.performed_by.last_name || ""
                      }`.trim()
                    : "-"}
                </p>

                <p>
                  <span className="font-medium">Usuario:</span>{" "}
                  {log.performed_by.username}
                </p>
                <p>
                  <span className="font-medium">Rol:</span>{" "}
                  {UserRolesTranslations[log.performed_by.role_id]}
                </p>
                <p>
                  <span className="font-medium">Email:</span>{" "}
                  {log.performed_by.email || "-"}
                </p>
                <p>
                  <span className="font-medium">DNI:</span>{" "}
                  {log.performed_by.dni || "-"}
                </p>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
